import type { RefObject } from "react";
import { useEffect, useRef } from "react";

type HookParams = RefObject<HTMLDivElement | null>;

type HookValue = RefObject<number>;

export const useElementMaxHeightRef = (containerRef: HookParams): HookValue => {
    const maxContainerHeightRef = useRef<number>(0);

    useEffect(() => {
        if (!containerRef.current || maxContainerHeightRef.current !== 0) {
            return;
        }

        const updateMaxHeight = (): void => {
            if (!containerRef.current) {
                return;
            }

            const currentHeight = containerRef.current.clientHeight;

            if (currentHeight > maxContainerHeightRef.current) {
                maxContainerHeightRef.current = currentHeight;
            }
        };

        const resizeObserver = new ResizeObserver(updateMaxHeight);
        resizeObserver.observe(containerRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    });

    return maxContainerHeightRef;
};
